<template>
  <div>
   <div class="login_tit">
      <img src="../../assets/image/xf_vue_index.jpg" hight="100px" width="100px" alt="center">
   </div>
    <section style="padding: 30px 30px; display: flex; flex-flow: column nowrap;">
      <div style="font-size: 20px; font-weight: bold">验证手机号</div>
      <!-- <div>验证码已通过短信发送至&nbsp;{{ tel }}</div> -->
      <div>
        <van-cell-group>
			<van-field
			        v-model="tel"
			        clearable
			        placeholder="请输入手机号"
			        style="background-color: WhiteSmoke"
			        v-validate="'required|mobile'"
			        ref="phone"
			        @blur="blur"
			>
			</van-field>
          <van-field
                  v-model="sms"
                  center
                  clearable
                  placeholder="请输入验证码"
                  style="background-color: WhiteSmoke"
				  v-validate="'required'"
                  ref="code"
          >
            <van-button slot="button" size="small" type="default" :disabled="disabled" @click="sendCode">{{ text }}</van-button>
          </van-field>
        </van-cell-group>
        <span style="color: red" v-show="errMsg">{{ errMsg }}</span>
      </div>
      <div style="background-color: DarkGray">
        <van-button :type="type" block :disabled="loginDisabled" @click="login">下一步</van-button>
      </div>
    </section>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import {isCode,isPhone,IsCard} from '@/utils/commons'
  import {auth_data}  from "@/utils/auth";
  import { sendLoginCode, loginByCode } from "@/api";

  export default {
    name: "LoginByCode",
    components: {NavBar},
    watch: {
      sms(newVal, oldVal){
        this.sms = this.sms.replace(/\s+/g, '').replace(/\D/g, '');
        if (isNaN(newVal) || newVal.length > 6) {
          this.sms = oldVal;
        }
        if(isCode(newVal)){
          //this.login();
          this.type = 'danger';
          this.loginDisabled = false
        }else{
          this.type = 'default';
          this.loginDisabled = 'disabled'
        }
      }
    },
    mounted(){
      this.$refs.code.focus()
    },
    data(){
      return{
        tel: this.$store.state.phone,
        sms: '',
        text: '发送验证码',
        disabled: false,
        loginDisabled: 'disabled',
        type: 'default',
        errMsg: '',
      }
    },
    methods: {
		blur(){
		  // 修改store中phone
		  if(isPhone(this.tel)){
		    this.$store.commit('updatePhone', this.tel)
		  }
		},
      // 验证
      login(){
		  let that=this;
		  // var _enc_str = 'secrit-key-43bc5ddc3487b34fc846014c2f4bd2ec';
		  // var mdcode = this.sms + _enc_str;
		  var key = auth_data(this.sms);
		  if(key == this.$store.state.code){
			  that.$router.push('/RetrievePwd');
		  }else{
			  that.errMsg = '验证码错误'
			  that.$refs.code.focus();
		  }

      },
      // 发送验证码
      sendCode(){
        let params = {
          phone: this.tel
        };
        sendLoginCode(params).then(data => {
          if (data.code === 200) {
            this.disabled = 'disabled';
			this.$store.commit('updateCode', data.data);
            this.timer()
          }
        });
      },
      // 60s计时器
      timer(){
        let i = 60;
        this.text = i;
        let timerId = setInterval(() => {
          if(i === 0){
            clearInterval(timerId);
            this.text = "重新发送";
            this.disabled = false;
            return
          }
          this.text = --i;
        }, 1000);
      }
    },
    created(){
      //this.sendCode();
    }
  }
</script>

<style scoped>
	.login_tit {
	  display: flex;
	  justify-content: center;
	  align-items: center;
	}
	.login_tit img{
	  width : 100%;
	}
  section div{
    margin-bottom: 16px;
  }
</style>
